exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*@import '../../../styles/vars.css';*/\r\n\r\n.scroll-block-image_image__1Cwhg {\r\n  width: 99%;\r\n  margin: 10px auto;\r\n  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.6);\r\n}", "", {"version":3,"sources":["W:/projects/brownfield/src/components/common/scroll-block-image/W:/projects/brownfield/src/components/common/scroll-block-image/index.module.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;CAC5C","file":"index.module.css","sourcesContent":["/*@import '../../../styles/vars.css';*/\r\n\r\n.image {\r\n  width: 99%;\r\n  margin: 10px auto;\r\n  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.6);\r\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"image": "scroll-block-image_image__1Cwhg"
};